export default __webpack_public_path__ + "static/media/Prancheta 4.65f17782.svg";